var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgDailyBonusStar = function SvgDailyBonusStar(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 11 10"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#daily-bonus-star_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#FFEE82",
    d: "M10.757 4.542c.476-.44.213-1.205-.443-1.295L7.9 2.914a.8.8 0 0 1-.603-.415L6.217.424c-.292-.565-1.141-.565-1.434 0l-1.08 2.075a.8.8 0 0 1-.602.415l-2.414.333c-.657.09-.92.856-.444 1.295L1.99 6.158a.74.74 0 0 1 .23.672L1.807 9.11c-.112.62.575 1.093 1.162.8l2.159-1.076a.84.84 0 0 1 .745 0l2.16 1.077c.586.293 1.272-.18 1.16-.801L8.782 6.83a.74.74 0 0 1 .23-.672z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "daily-bonus-star_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h11v10H0z"
  })))));
};
export default SvgDailyBonusStar;